import axios from 'axios';

/**
 * @param {string} text
 */
// eslint-disable-next-line import/prefer-default-export
export async function hsCodeFind(text) {
    try {
        const response = await axios({
            method: 'post',
            url: '/api/v2/hsCodes/find',
            withCredentials: true,
            data: {
                text,
            },
        });
        return response.data.data;
    } catch (error) {
        return error.response;
    }
}



// WEBPACK FOOTER //
// ./app/services/hsCodes.js